import { useAppSelector } from "redux/store";
import { selectLogin } from "redux/selectors";
import { FC, useEffect } from "react";
import { useBucketContext } from "context/bucket";

export const SummaryContentFooter: FC = () => {
  const { session, guid } = useAppSelector(selectLogin);
  const { fetchBucketSummary, bucketSummary } = useBucketContext();

  useEffect(() => {
    fetchBucketSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return bucketSummary ? (
    <div className="text-center text-light p-2 shadow-lg fs-sm-12 fw-light">
      <p>
        Account <span className="fw-bold">{guid}</span> relativo a{" "}
        <span className="fw-bold">{session?.Nome}</span>
      </p>
      <p>
        Occupazione complessiva {bucketSummary.dimension} (
        {bucketSummary.numberOfFiles} file)
      </p>
    </div>
  ) : null;
};
